/**
 * Helper to interpolate between two colors based on a given ratio.
 *
 * @param {string} color1 - The first color in hexadecimal format.
 * @param {string} color2 - The second color in hexadecimal format.
 * @param {number} ratio - The ratio between the two colors (between 0 and 1).
 * @returns {string} The interpolated color in hexadecimal format.
 */
const interpolateColor = (color1, color2, ratio) => {
    let r = Math.ceil(
      parseInt(color1.substring(1, 3), 16) * ratio +
        parseInt(color2.substring(1, 3), 16) * (1 - ratio)
    );
    let g = Math.ceil(
      parseInt(color1.substring(3, 5), 16) * ratio +
        parseInt(color2.substring(3, 5), 16) * (1 - ratio)
    );
    let b = Math.ceil(
      parseInt(color1.substring(5, 7), 16) * ratio +
        parseInt(color2.substring(5, 7), 16) * (1 - ratio)
    );
  
    return `#${r.toString(16).padStart(2, '0')}${g
      .toString(16)
      .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  };
  
  /**
   * Returns the color based on the given score value.
   *
   * @param {number} value - The value to determine the color.
   * @returns {string} The color based on the value.
   */
  const getColor = (value) => {
    const color1 = '#efad9d';
    const color2 = '#fedf88';
    const color3 = '#98ceb0';
  
    if (value >= 60) {
      return value >= 80
        ? color3
        : interpolateColor(color3, color2, (value - 60) / 20);
    } else if (value >= 20) {
      return value >= 40
        ? color2
        : interpolateColor(color2, color1, (value - 20) / 20);
    } else {
      return color1;
    }
  };
  
  export default getColor;